/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type consultAnExpert_viewer$ref: FragmentReference;
export type consultAnExpert_viewer = {|
  +isConsultAnExpertDisabled: ?boolean,
  +$refType: consultAnExpert_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "consultAnExpert_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isConsultAnExpertDisabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_CONSULT_AN_EXPERT",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ce3292977b99c58ac6db4bda3ebc027b';
module.exports = node;
